import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 8l8 8l8-8h-4V0H4v8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDown
